<p-dialog
  [(visible)]="visible"
  [maximizable]="config.maximizable"
  (onShow)="handleDialogShow()"
  (onMaximize)="handleMaximize($event)"
  (onHide)="hideDialog()"
  [style]="{ width: '450px' }"
  [header]="generalTexts.titleText.label"
  [modal]="true"
  styleClass="p-fluid"
>
  <ng-template pTemplate="content">
    <form [formGroup]="entityForm">
      <div class="p-grid">
        <ng-container *ngFor="let col of fields">
          <ng-container *ngIf="col.type == 'hidden'; else fromcontrol">
            <input type="hidden" [formControlName]="col.field" />
          </ng-container>
          <ng-template #fromcontrol>
            <div class="p-mt-2" [ngClass]="controlClass(col)">
              <div class="p-field">
                <label for="{{ col.field }}">
                  {{ col.label }}
                  <span style="color: red" *ngIf="col?.validations?.length"
                    >*</span
                  >
                </label>
                <ng-container [ngSwitch]="col.type">
                  <ng-container *ngSwitchCase="'select'">
                    <p-dropdown
                      [options]="col.source"
                      [formControlName]="col.field"
                      [placeholder]="col.placeholder || col.label"
                      [showClear]="true"
                      [autofocusFilter]="false"
                      [filter]="true"
                      appendTo="body"
                      optionLabel="{{ col.optionKey || 'text' }}"
                      [dataKey]="col.dataKey || 'id'"
                    ></p-dropdown>
                  </ng-container>
                  <ng-container *ngSwitchCase="'user-auto-select'">
                    <p-autoComplete
                      dataKey="id"
                      [suggestions]="col.source"
                      [formControlName]="col.field"
                      (completeMethod)="searchUser($event, col.name)"
                      [field]="col.optionLabel || 'fullName'"
                      appendTo="body"
                      [minLength]="3"
                      [delay]="2000"
                      [placeholder]="col.placeholder || 'Search'"
                    ></p-autoComplete>
                  </ng-container>
                  <ng-container *ngSwitchCase="'multiselect'">
                    <p-multiSelect
                      [options]="col.source"
                      [formControlName]="col.field"
                      [placeholder]="col.placeholder || col.label"
                      [autofocusFilter]="false"
                      appendTo="body"
                      optionLabel="{{ col.optionKey || 'text' }}"
                      [dataKey]="col.dataKey || 'id'"
                    ></p-multiSelect>
                  </ng-container>
                  <ng-container *ngSwitchCase="'color'">
                    <div class="p-d-flex">
                      <div class="p-col-1">
                        <p-colorPicker
                          [formControlName]="col.field"
                          [style]="{ width: '35px' }"
                          (onChange)="onColorChange($event.value, col.field)"
                          appendTo="body"
                        ></p-colorPicker>
                      </div>
                      <div class="p-col p-ml-3">
                        <input
                          type="text"
                          pInputText
                          id="{{ col.field }}"
                          [formControlName]="col.field"
                          [placeholder]="col.placeholder || col.label"
                        />
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'checkbox'">
                    <div class="p-d-flex">
                      <div class="p-col">
                        <p-checkbox
                          [binary]="col.boolean"
                          name="col.field"
                          value="1"
                          [formControlName]="col.field"
                        >
                        </p-checkbox>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'image'">
                    <div class="p-d-flex">
                      <div class="p-col">
                        <small>Max. Image size should be lower than 2MB.</small>
                        <p-fileUpload
                          [files]="files"
                          accept=".jpg, .jpeg, .png, .gif, .bmp, .tiff, .tif, .webp, .svg, .ico, .heif, .heic, .jp2, .psd, .pbm, .pgm, .ppm, .pcx, .xpm, .cr2, .nef, .exif, .dds, .tga, .hdr, .wbmp, .iff, .icns"
                          [showCancelButton]="true"
                          [cancelLabel]="'Clear File'"
                          [showUploadButton]="false"
                          [formControlName]="col.field"
                          [maxFileSize]="2000000"
                          [chooseLabel]="generalTexts.choose.label"
                          (onClear)="onImageClear(col.field)"
                          (onSelect)="onImageUpload($event, col.field)"
                        >
                        </p-fileUpload>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'number'">
                    <div class="p-d-flex">
                      <div class="p-col">
                        <p-inputNumber
                          [formControlName]="col.field"
                          id="{{ col.field }}"
                          mode="decimal"
                          [showButtons]="true"
                          inputId="minmax-buttons"
                          min="{{ col.min !== undefind ? col.min : 'null' }}"
                          max="{{ col.max !== undefind ? col.max : 'null' }}"
                          [placeholder]="col.placeholder || col.label"
                        >
                        </p-inputNumber>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'textarea'">
                    <div>
                      <textarea
                        id="{{ col.field }}"
                        [formControlName]="col.field"
                        type="text"
                        rows="4"
                        [ascCharacterLimit]="
                          col.maxLength || constants.max1000Char
                        "
                        pInputTextarea
                      ></textarea>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <ng-container *ngIf="!(col.type && col.type)">
                      <div>
                        <input
                          *ngIf="!(newRecord && col.field == 'id')"
                          type="text"
                          [ascCharacterLimit]="
                            col.maxLength || constants.max250Char
                          "
                          pInputText
                          id="{{ col.field }}"
                          [formControlName]="col.field"
                          [placeholder]="col.placeholder || col.label"
                        />
                      </div>
                    </ng-container>
                  </ng-container>
                  <small id="{{ col.field }}-help" *ngIf="col.helpText">{{
                    col.helpText
                  }}</small>
                </ng-container>
                <ng-container *ngFor="let validation of col.validations">
                  <small
                    class="p-invalid"
                    *ngIf="
                      getControl(col.field).touched &&
                      getControl(col.field).errors
                    "
                  >
                    <p *ngIf="getControl(col.field).errors[validation.name]">
                      {{ validation.message }}
                    </p>
                  </small>
                </ng-container>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </div>
    </form>
  </ng-template>

  <ng-template pTemplate="footer" *ngIf="!readonly">
    <button
      pButton
      pRipple
      [label]="generalTexts.cancelButton.label"
      icon="pi pi-times"
      class="p-button-text"
      (click)="hideDialog()"
    ></button>
    <button
      pButton
      pRipple
      [label]="generalTexts.saveButton.label"
      icon="pi pi-check"
      class="p-button-text"
      [disabled]="entityForm.invalid"
      (click)="saveData()"
    ></button>
  </ng-template>
</p-dialog>
<p-toast position="top-right" key="entity"></p-toast>
